import React from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import { Admin, AppBar, Layout, MenuItemLink, Resource, UserMenu } from 'react-admin';
import { DeviceCreate, DeviceEdit, DeviceList, DeviceShow, OwnerEdit, OwnerShow } from './components/views';
import authProvider from './providers/authProvider';
import simpleRestProvider from './providers/dataProvider';

const ApiUserMenu = props => (
    <UserMenu {...props}>
        <MenuItemLink
            to="/owners/current"
            primaryText="Settings"
            leftIcon={<SettingsIcon />}
        />
    </UserMenu>
);

const ApiAppBar = props => <AppBar {...props} userMenu={<ApiUserMenu />} />;

const ApiLayout = props => <Layout {...props} appBar={ApiAppBar} />;

export default () => (
    <Admin authProvider={authProvider} dataProvider={simpleRestProvider(process.env.REACT_APP_SERVER)} layout={ApiLayout} title='Lora Portal'>
        <Resource name="owners/current/devices" options={{ label: 'Devices' }} create={DeviceCreate} edit={DeviceEdit} list={DeviceList} show={DeviceShow} />
        <Resource name="networkServers" />
        <Resource name="owners" edit={OwnerEdit} show={OwnerShow} />
    </Admin>
);
